import {
  setUserTermsAndConditionsRequested,
  setUserTermsAndConditionsReceived,
} from './userTermsAndConditionsSlice';
import { getUserAcceptedTermsHasAccepted } from '../../services/userTermsAndConditionsService';

export const getUserTermsAndConditionsThunk = (email) => async (dispatch) => {
  dispatch(setUserTermsAndConditionsRequested());
  const hasAccepted = await getUserAcceptedTermsHasAccepted(email);
  dispatch(setUserTermsAndConditionsReceived(hasAccepted));
};
